msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fi\n"
"Project-Id-Version: 5b236266dda1bdf711f2dec226a4db34\n"
"Report-Msgid-Bugs-To: \n"
"Last-Translator: \n"
"Language-Team: Finnish\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: 5b236266dda1bdf711f2dec226a4db34\n"
"X-Crowdin-Project-ID: 574\n"
"X-Crowdin-Language: fi\n"
"X-Crowdin-File-ID: 25408\n"

#. Suffix part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the ' | FINN.no' part, including the space at the beginning)
#. js-lingui-explicit-id
#: src/server/server.ts:225
msgid "page.title.suffix"
msgstr " | Tori"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:230
#: src/server/pages/default-landing.tsx:117
msgid "content.card2.title"
msgstr "... Julkaise ilmoitus helposti tekoälyn avulla"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:27
#: src/server/pages/images.ts:68
#: src/server/pages/images.ts:110
msgid "content.image.finn.intro2.alt"
msgstr "Kermanvärinen neulottu poolopusero ja sen edessä käsi, joka pitelee älypuhelinta, jonka näytöllä näkyy kuva samasta puserosta vaaleanpunaisella taustalla."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:318
#: src/server/pages/default-landing.tsx:234
msgid "content.steps.step3.description"
msgstr "Tekoäly ehdottaa ilmoitukselle otsikon ja kuvauksen. Sinun tarvitsee vain lisätä hinta ja osoite ennen julkaisua."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:291
#: src/server/pages/default-landing.tsx:207
msgid "content.steps.step1.description"
msgstr "Kuvakulma, valaistus, kuvien määrä – tekoäly antaa sinulle hyviä vinkkejä ilmoituksen laatimiseen!"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:35
msgid "content.image.finn.intro3.alt"
msgstr "Lähikuva älypuhelimesta, jonka näytöllä näkyy viesti FINN-sovelluksesta, jossa lukee että rahat ovat matkalla ja näkyvät käyttäjän tilillä 2–5 arkipäivän kuluessa, sekä sumea ja lämminsävyinen tausta."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:76
#: src/server/pages/images.ts:118
msgid "content.image.tori.intro3.alt"
msgstr "Lähikuva älypuhelimesta, jonka näytöllä näkyy viesti Tori-sovelluksesta, jossa lukee että rahat ovat matkalla ja näkyvät käyttäjän tilillä noin 2–5 arkipäivän kuluessa, sekä taustalla sumea, lämminsävyinen kuva valoista."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:43
msgid "content.image.finn.aiHelper.alt"
msgstr "Lähikuva älypuhelimesta, jonka näytöllä näkyy FINNin AI-apurin käyttöliittymä, joka täyttää automaattisesti tuotetiedot, kuten merkin, tyypin, koon ja värin, sekä ohjeteksti siitä, että käyttäjä voi korjata virheelliset tiedot itse."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:84
#: src/server/pages/images.ts:126
msgid "content.image.tori.aiHelper.alt"
msgstr "Lähikuva älypuhelimesta, jonka näytöllä näkyy Torin AI-apurin käyttöliittymä, joka täyttää automaattisesti tuotetiedot, kuten merkin, tyypin ja koon, sekä ohjeteksti siitä, että käyttäjä voi korjata virheelliset tiedot itse."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:19
#: src/server/pages/images.ts:60
#: src/server/pages/images.ts:102
msgid "content.image.finn.intro1.alt"
msgstr "Kermanvärinen neulottu poolopusero, jossa on pintakuvioita, joustinneulottu kaulus ja kaksi nappia ja joka on siististi viikattuna vasten vaaleanpunaista taustaa."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:313
#: src/server/pages/default-landing.tsx:229
msgid "content.steps.step3.title"
msgstr "Tietoja täytetään automaattisesti"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:56
msgid "content.title"
msgstr "Onko sinulla aarteita varastossa?"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:208
#: src/server/pages/default-landing.tsx:95
msgid "content.card1.title"
msgstr "Käy läpi tavarat, joita et käytä."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:51
msgid "content.image.finn.testimonial.alt"
msgstr "Vigdísin kasvokuva"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:279
#: src/server/pages/default-landing.tsx:197
msgid "content.steps.title"
msgstr "Näin AI-apuri toimii"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:299
#: src/server/pages/default-landing.tsx:215
msgid "content.steps.step2.title"
msgstr "Anna tekoälyn etsiä oikea osasto"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:213
#: src/server/pages/default-landing.tsx:100
msgid "content.card1.description"
msgstr "Onko kaapissa käyttämättä jäänyt takki tai vanha iPad? Ansaitse laittamalla tavarat kiertoon. Oma tarpeeton voi olla toisen aarre."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:252
#: src/server/pages/default-landing.tsx:137
msgid "content.card3.title"
msgstr "Rahat suoraan kukkaroosi!"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:59
msgid "content.description"
msgstr "Nyt on aika myydä kaapistasi tavarat, joita et enää käytä. Torin uudella tekoälytyökalulla myynti-ilmoituksen tekeminen kestää alle 2 minuuttia."

#. js-lingui-explicit-id
#: src/islands/create-item-button/create-item-button.tsx:43
msgid "button.createItem"
msgstr "Luo myynti-ilmoitus"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:326
#: src/server/pages/default-landing.tsx:242
msgid "content.steps.step4.title"
msgstr "Julkaise"

#. Main part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the 'Selg med AI' part)
#. js-lingui-explicit-id
#: src/server/server.ts:218
msgid "page.title.main"
msgstr "Myy tekoälyn avulla"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:235
#: src/server/pages/default-landing.tsx:120
msgid "content.card2.description"
msgstr "Ota kuva tavarasta, jonka haluat myydä, niin tekoäly auttaa sinua ilmoituksen otsikon, tekstin ja osaston kanssa."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:286
#: src/server/pages/default-landing.tsx:202
msgid "content.steps.step1.title"
msgstr "Ota parhaat mahdolliset kuvat"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:304
#: src/server/pages/default-landing.tsx:220
msgid "content.steps.step2.description"
msgstr "Kuvia analysoidaan jatkuvasti, ja myytävä tavara sijoitetaan automaattisesti oikeaan osastoon Torissa."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:257
#: src/server/pages/default-landing.tsx:142
msgid "content.card3.description"
msgstr "Rahat siirtyvät turvallisesti suoraan tilillesi heti, kun ostaja on maksanut tavaran Torin kautta."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:329
#: src/server/pages/default-landing.tsx:245
msgid "content.steps.step4.description"
msgstr "Tätä vaihetta ei tekoäly tee puolestasi. Julkaise ilmoitus klikkaamalla."

